import { Text2, skinVars } from '@telefonica/mistica';
import { t } from 'i18next';
import React, { useState } from 'react';
import { IChatComponent } from '../../pages/support/solveIncident';
import { formatMobileNumber } from '../../utils/dataTransformation/unitsConversion';
import ChatSupport from '../ChatSupport';
import ChatText from '../ChatText';
import './index.scss';

interface IChatNumberProduct {
    onEmitNumber: Function;
    item: IChatComponent;
}

export const ChatNumberProduct: React.FC<IChatNumberProduct> = ({ onEmitNumber, item }: IChatNumberProduct) => {
    const [selectNumber, setSelectNumber] = useState(true);
    const [selectedNumber, setSelectedNumber] = useState();

    const selectTabNumber = (line: any) => {
        const { product } = item;
        const { id, type, motive } = product;
        setSelectNumber(false);
        setSelectedNumber(line?.number);
        onEmitNumber({ product: { id, type, motive, products: [line] }, step: 3 });
    };

    const selectedNumberProblem = () => {
        if (selectNumber === false) {
            return <ChatText context={'response'} text={`${formatMobileNumber(selectedNumber)}`}></ChatText>;
        }
    };

    return (
        <div className='chatNumberProduct'>
            <div>
                <ChatSupport text={t('supportAnswerChatNumbers')}></ChatSupport>
                {selectNumber &&
                    item?.product?.products?.map((item: any, index: number) => {
                        return (
                            <div
                                key={index}
                                onClick={() => selectTabNumber(item)}
                                className='chatNumberProduct__number'
                                style={{
                                    borderStyle: 'solid',
                                    borderWidth: '1px',
                                    borderColor: skinVars.colors.controlActivated,
                                }}
                            >
                                <Text2 regular color={skinVars.colors.textLink}>
                                    {formatMobileNumber(item?.number)}
                                </Text2>
                            </div>
                        );
                    })}
                {selectedNumberProblem()}
            </div>
        </div>
    );
};

export default ChatNumberProduct;
